import { jsx as i } from "react/jsx-runtime";
import { Rating as n } from "./designsystem-ui-react27.js";
function p({
  rating: r,
  amountOfRatings: t,
  isCompact: o = !1,
  inverted: a = !1,
  className: f
}) {
  return /* @__PURE__ */ i(
    n,
    {
      amountOfRatings: t,
      className: f,
      inverted: a,
      isCompact: o,
      rating: r
    }
  );
}
export {
  p as CardRating
};
